export const INJECTABLE_METADATA_KEY = 'async-injection:INJECTABLE';
export const INJECT_METADATA_KEY = 'async-injection:INJECT';
export const POSTCONSTRUCT_SYNC_METADATA_KEY = 'async-injection:POSTCONSTRUCT_SYNC';
export const POSTCONSTRUCT_ASYNC_METADATA_KEY = 'async-injection:POSTCONSTRUCT_ASYNC';
export const RELEASE_METADATA_KEY = 'async-injection:RELEASE';
export const OPTIONAL_METADATA_KEY = 'async-injection:OPTIONAL';

export const REFLECT_PARAMS = 'design:paramtypes';
export const REFLECT_RETURN = 'design:returntype';
